import { render, staticRenderFns } from "./Materiel.vue?vue&type=template&id=75ac83b6"
import script from "./Materiel.vue?vue&type=script&lang=js"
export * from "./Materiel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ac83b6')) {
      api.createRecord('75ac83b6', component.options)
    } else {
      api.reload('75ac83b6', component.options)
    }
    module.hot.accept("./Materiel.vue?vue&type=template&id=75ac83b6", function () {
      api.rerender('75ac83b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/base/dictionary/medicinedic/Materiel.vue"
export default component.exports